import React, { FC } from 'react';
import { Button } from '@common/components/Button';
import { ReduxFormInput } from '@common/components/FormElements/BlockInputField';
import { Modal } from '@common/components/Modal';
import { Link } from 'shared-routing';
import {
  ForgottenPasswordLink,
  LoginMethodForm,
  LoginMethodItemContent,
  StyledForm,
  StyledLabel,
  SubmitButtonWrapper,
} from '@features/checkout/pages/CheckoutLogin/components/styled';
import Error from '@common/components/Error';

import { Routes } from '@common/constants';
import { useTranslations } from '@lang';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';

import { FormValues } from '../SignIn.types';
import { SignInModalFormProps } from './SignInModalForm.types';
import { ModalWrapper } from './SignInModalForm.styles';
import { validate } from './validate';

const SignInModalForm: FC<
  SignInModalFormProps & InjectedFormProps<FormValues, SignInModalFormProps>
> = ({ isModalOpen = false, handleSubmit, handleModalClose, loginError = null }) => {
  const { t } = useTranslations();

  return (
    <Modal
      isOpen={isModalOpen}
      onBackgroundClick={handleModalClose}
      onEscapeKeydown={handleModalClose}
    >
      <ModalWrapper>
        <StyledForm onSubmit={handleSubmit} noValidate>
          <LoginMethodItemContent>
            <StyledLabel htmlFor="sign-in">{t('secureCheckout.signIn')}</StyledLabel>

            {loginError && <Error error={{ code: loginError }} />}

            <LoginMethodForm>
              <Field
                isRequired
                component={ReduxFormInput}
                name="email"
                label={t('secureCheckout.email')}
              />
              <Field
                isRequired
                component={ReduxFormInput}
                type="password"
                name="password"
                label={t('secureCheckout.password')}
              />
              <ForgottenPasswordLink>
                <Link route={Routes.FORGOTTEN_PASSWORD}>
                  {t('secureCheckout.forgotYourPassword')}
                </Link>
              </ForgottenPasswordLink>
              <SubmitButtonWrapper>
                <Button isPrimary>{t('secureCheckout.signIn')}</Button>
              </SubmitButtonWrapper>
            </LoginMethodForm>
          </LoginMethodItemContent>
        </StyledForm>
      </ModalWrapper>
    </Modal>
  );
};

export default reduxForm<FormValues, SignInModalFormProps>({
  form: 'SignInForm',
  validate,
})(SignInModalForm);
